import React, { createContext, useContext, useMemo } from "react";
import AuthService from "../services/AuthService";
import { useNotification } from "./NotificationContext";
import { useClient } from "./ClientContext";

const AuthContext = createContext<AuthService | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const notification = useNotification();
  const authClient = useClient("AUTH_SERVICE");
  const client = useMemo(() => authClient, []);
  const authService = useMemo(
    () => new AuthService(client, notification),
    [client]
  );

  return (
    <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>
  );
};

export const useAuth = (): AuthService => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
